import { UseFormSetValue } from 'react-hook-form';

import { TAgentLocation } from '@cloud-wave/neon-common-lib';

import { TExtendedAgentPreferenceFormSchema } from 'lib/common/contexts/AgentPreferenceContext/MyLocationModal/schema/agentPreferenceFormSchema';

export function setLocationValues(
  setValue: UseFormSetValue<TExtendedAgentPreferenceFormSchema>,
  location: TAgentLocation,
  callbackNumber?: string | null
) {
  setValue('location.streetNumber', location.streetNumber ?? '');
  setValue('location.streetDirection', location.streetDirection ?? '');
  setValue('location.streetInfo', location.streetInfo ?? '');
  setValue('location.unitNumber', location.unitNumber ?? '');
  setValue('location.city', location.city ?? '');
  setValue('location.state', location.state ?? '');
  setValue('location.postalCode', location.postalCode ?? '');
  if (callbackNumber !== undefined) {
    setValue('callbackNumber', callbackNumber ?? '');
  }
}
